//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_COLORS_LIGHTER_TINTS = {
    color: [
        'var(--ods-cyan-light, #B5E8F7)',
        'var(--ods-teal-light, #B8EBD6)',
        'var(--ods-pink-light, #FFE8F7)',
        'var(--ods-indigo-light, #D9C2F0)',
        'var(--ods-yellow-light, #FFF6B6)',
    ],
};
